<template>
<div style="padding: 0 20px;box-sizing: border-box">
  <div style="height: 40px">
    <el-date-picker v-fixZoom v-model="sendTime" type="daterange" range-separator="至" size="small"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
    </el-date-picker>
    <el-button size="small" type="primary" @click="searchQuery">查询</el-button>
  </div>
  <el-table size="small" height="300px" element-loading-text="加载中，请耐心等待。" :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
    <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
    <el-table-column prop="paid_date" label="缴费金额" min-width="110" align="center"></el-table-column>
    <el-table-column prop="fee_amount" label="缴费时间" min-width="110" align="center"></el-table-column>
    <el-table-column prop="remarks" label="缴费备注" min-width="110" align="center"></el-table-column>
  </el-table>
  <div style="margin-top: 10px;height: 40px;text-align: center">
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                   :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
    </el-pagination>
  </div>
</div>
</template>

<script>
import {querypersoncarefeepaymentshistory} from '../../../api/serviceMark'

export default {
  name: 'paymentRecords',
  model: {
    prop: 'openRecordsShow',
    event: 'change'
  },
  props: {
    paymentObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      sendTime: []
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-30).format('yyyy-MM-dd')
    this.sendTime = [start, end]
    this.getTableRecords()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.getTableRecords()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTableRecords()
    },
    searchQuery () {
      this.currentPage = 1
      this.getTableRecords()
    },
    getTableRecords () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        from: this.sendTime[0] ? this.sendTime[0] + ' 00:00:00' : '',
        to: this.sendTime[1] ? this.sendTime[1] + ' 23:59:59' : '',
        pid: this.paymentObj.row.pid
      }
      querypersoncarefeepaymentshistory(params, data).then(res => {
        this.tableData = res.data.reminders
        this.totalCells = res.data.cnt
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/paymentRecords.vue